export default [
  {
    path: '/desk/setup',
    name: 'desk-setup',
    component: () => import('@/views/desk/setup/Setup.vue'),
    meta: {
      layout: 'desk',
    },
  },
  {
    path: '/desk/main',
    name: 'desk-main',
    component: () => import('@/views/desk/main/Main.vue'),
    meta: {
      layout: 'desk',
    },
  },
]
